import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LoginSchema, SignupSchema } from './ValidationSchema.js';
import Text from '../../input_fields/Text.jsx';
import Password from '../../input_fields/Password.jsx';
import SaveButton from '../../buttons/SaveButton.jsx';
import { loginTodo } from '../../../redux/slice/login.js';
import { toast } from 'react-toastify';
import { LuEye, LuEyeOff, LuShieldCheck, LuRefreshCw } from 'react-icons/lu'
import { BiHide, BiShow } from 'react-icons/bi';
import { chatLockUnlockStatus } from '../../../redux/slice/ChatLockUnlockStatus.js';
import { updateCookiesTodo } from '../../../redux/slice/UpdateCookies.js';
import { CONSENT_UPDATED_EVENT, requestCookieConsentIfNeeded } from '../../../utils/cookieConsent.js';

const LoginForm = (props) => {

    const [spinner, setSpinner] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const [newPswShow, setNewPswShow] = useState(false);
    const pendingAuthRef = useRef(false);

    const togglePassword = () => {
        setNewPswShow(!newPswShow);
    }
    const initialValues = {
        email: "",
        password: ""
    };



    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: LoginSchema,

        onSubmit: (values, action) => {
            if (!captchaInput.trim()) {
                setCaptchaError('Please enter CAPTCHA');
                return;
            }
            if (captchaInput !== captchaText) {
                setCaptchaError('Captcha Mismatch');
                refreshCaptcha();
                return;
            }
            pendingAuthRef.current = true;
            if (requestCookieConsentIfNeeded()) {
                pendingAuthRef.current = false;
            } else {
                return;
            }
            setSpinner(true);
            dispatch(loginTodo({ values })).then((res) => signup_res(res.payload));
        }
    });

    useEffect(() => {
        const onConsentUpdated = () => {
            if (!pendingAuthRef.current) return;
            pendingAuthRef.current = false;
            handleSubmit();
        };
        window.addEventListener(CONSENT_UPDATED_EVENT, onConsentUpdated);
        return () => window.removeEventListener(CONSENT_UPDATED_EVENT, onConsentUpdated);
    }, [handleSubmit]);

    const signup_res = (res, action) => {
        if (res?.status == 200 || res?.status == 201) {
            if (res?.data?.user_status === 'Active' && res?.data?.data?.[0]?.user_verified == 'verified') {
                localStorage.setItem('id', res?.data?.data[0]?.id)
                localStorage.setItem('name', res?.data?.data[0]?.name)
                localStorage.setItem('email', res?.data?.data[0]?.email)
                localStorage.setItem('user_verified', res?.data?.data[0]?.user_verified)
                localStorage.setItem('token', res?.data?.data[0]?.Token)
                localStorage.setItem('user_name', res?.data?.data[0]?.user_name)
                localStorage.setItem('profile_url', res?.data?.data[0]?.profile_url)
                localStorage.setItem('profile_photo', res?.data?.data[0]?.profile_photo)
                localStorage.setItem('biolink_status', res?.data?.data[0]?.biolink_status)
                localStorage.setItem('biolink_expire_date', res?.data?.data[0]?.biolink_expire_date)
                localStorage.setItem('city_id', res?.data?.data[0]?.city_id)
                localStorage.setItem('city_name', res?.data?.data[0]?.city_name)
                localStorage.setItem('company_name', res?.data?.data[0]?.company_name)
                localStorage.setItem('address', res?.data?.data[0]?.address)
                localStorage.setItem('gstnumber', res?.data?.data[0]?.gstnumber)

            }
            dispatch(updateCookiesTodo())
            dispatch(chatLockUnlockStatus({ navigate })).then((res) => {
                if (res?.payload?.status === 200) {
                    localStorage.setItem('chat_lock_unlock_status', res?.payload?.data?.data?.is_chat_locked)
                }
            })
            toast.success(res?.data?.message, { position: "bottom-right" })
            setSpinner(false)
            setTimeout(() => {
                res?.data?.user_status === 'Inactive' && res?.data?.data?.[0]?.user_verified == 'non-verified' ?
                    navigate('/otp-verify', { state: { email: res?.data?.data?.[0]?.email, from: location.pathname } }) :
                    res?.data?.user_status === 'Inactive' && res?.data?.data?.[0]?.user_verified == 'verified' ? navigate('/login') :
                        location?.state?.from ? navigate(location?.state?.from) :
                            navigate('/dashboard');
            }, 1500);
        }
        //  else if (res?.status == 400) {
        //     if (res?.data?.user_status == 'Deleted') {
        //         Swal.fire({
        //             title: "Account Information",
        //             text: res?.data?.message,
        //             icon: 'question',
        //             showCancelButton: true,
        //             confirmButtonColor: '#121136',
        //             cancelButtonColor: '#EF3D50',
        //             cancelButtonText: 'Cancel',
        //             confirmButtonText: 'Restore Account'
        //         }).then((result) => {
        //             if (result.isConfirmed) {
        //                 dispatch(profileRenewedTodo(res?.data?.data?.[0]?.id)).then((res) => {
        //                     if (res?.payload?.status == 200) {
        //                         setSpinner(false)
        //                         toast.success(res?.payload?.data?.message, { position: "bottom-right" })
        //                     } else {
        //                         toast.error(res?.payload?.data?.message, { position: "bottom-right" })
        //                     }
        //                 })
        //             }
        //         })
        //     } else {
        //         setSpinner(false)
        //         toast.error(res?.data?.message, { position: "bottom-right" })
        //     }

        // }
        else if (res?.status == 400) {
            setSpinner(false)
            toast.error(res?.data?.message, { position: "bottom-right" })
        }
        else if (res?.status == 404) {
            setSpinner(false)
            toast.error(res?.data?.message, { position: "bottom-right" })
        } else if (res?.status == 500) {
            setSpinner(false)
            toast.error("Server error!!..", { position: "bottom-right" })
        } else {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        }
    }


    // CAPTCHA FUNCTION 
function generateCaptchaText(length = 5) {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'
    let text = ''
    for (let i = 0; i < length; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return text
}
    function drawCaptcha(canvas, text) {
        if (!canvas) return
        const ctx = canvas.getContext('2d')
        const w = canvas.width
        const h = canvas.height

        // Background
        ctx.fillStyle = '#f0f4f8'
        ctx.fillRect(0, 0, w, h)

        // Noise lines
        for (let i = 0; i < 5; i++) {
            ctx.strokeStyle = `hsl(${Math.random() * 360}, 40%, 70%)`
            ctx.lineWidth = 1
            ctx.beginPath()
            ctx.moveTo(Math.random() * w, Math.random() * h)
            ctx.lineTo(Math.random() * w, Math.random() * h)
            ctx.stroke()
        }

        // Noise dots
        for (let i = 0; i < 30; i++) {
            ctx.fillStyle = `hsl(${Math.random() * 360}, 40%, 65%)`
            ctx.beginPath()
            ctx.arc(Math.random() * w, Math.random() * h, 1.5, 0, Math.PI * 2)
            ctx.fill()
        }

        // Draw each character with slight rotation
        const fontSize = 28
        ctx.font = `bold ${fontSize}px 'Courier New', monospace`
        ctx.textBaseline = 'middle'
        const startX = 18
        const spacing = (w - 36) / text.length

        for (let i = 0; i < text.length; i++) {
            ctx.save()
            const x = startX + i * spacing
            const y = h / 2 + (Math.random() * 8 - 4)
            const angle = (Math.random() - 0.5) * 0.4
            ctx.translate(x, y)
            ctx.rotate(angle)
            ctx.fillStyle = `hsl(${200 + Math.random() * 60}, 60%, 35%)`
            ctx.fillText(text[i], 0, 0)
            ctx.restore()
        }
    }

    const canvasRef = useRef(null)
    const [captchaText, setCaptchaText] = useState('')
    const [captchaInput, setCaptchaInput] = useState('')
    const [captchaError, setCaptchaError] = useState('')

    const refreshCaptcha = useCallback(() => {
        const newText = generateCaptchaText()
        setCaptchaText(newText)
        setCaptchaInput('')
        drawCaptcha(canvasRef.current, newText)
    }, [])

    useEffect(() => {
        refreshCaptcha()
    }, [refreshCaptcha])

    // Re-draw when captchaText changes and canvas is ready
    useEffect(() => {
        if (canvasRef.current && captchaText) {
            drawCaptcha(canvasRef.current, captchaText)
        }
    }, [captchaText])

    return (
        <>
            <Form onSubmit={(e) => {
                e.preventDefault();
                if (!captchaInput.trim()) {
                    setCaptchaError('Please enter CAPTCHA');
                    return;
                }
                if (captchaInput !== captchaText) {
                    setCaptchaError('Captcha Mismatch');
                    refreshCaptcha();
                    return;
                }
                setCaptchaError('');
                handleSubmit();
            }}>
                <div className="">
                    <div className='container-fluid'>
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="mb-4 biolink-title-gradient " >Login Your Account...!!</h2>
                            </div>


                            <div className="col-md-12">
                                <Text
                                    label_name={"Email"}
                                    placeholder='Enter your email address'
                                    disabled={false}
                                    name='email'
                                    value={values.email || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.email && touched.email ? (<span className='text-danger form_label'>{errors.email}</span>) : null}
                                />
                            </div>
                            <div className='col-md-12' style={{ position: 'relative' }}>
                                <label htmlFor="user_name" className="form-label form_label">Enter Password</label>
                                {newPswShow ? <span className="psw_icon" onClick={togglePassword} ><BiShow size={20} style={{ color: "grey" }} /></span> : <span className="psw_icon" onClick={togglePassword} ><BiHide size={20} style={{ color: "#9d9d9d" }} /></span>}
                                <input type={newPswShow ? "text" : "password"}
                                    name='password'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    className='form-control form_input' />
                                {errors.password && touched.password ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.password}</span>) : null}
                                {/* <PasswordStrengthBar password={values.password} /> */}
                            </div>
                            {/* <div className="col-md-12">
                                <Password
                                    label_name={"Password"}
                                    placeholder='Enter your password'
                                    disabled={false}
                                    name='password'
                                    value={values.password || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.password && touched.password ? (<span className='text-danger form_label'>{errors.password}</span>) : null}
                                />

                            </div> */}

                            <div className="login-input-group">
                                <label>CAPTCHA</label>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '8px',
                                }}>
                                    <canvas
                                        ref={canvasRef}
                                        width={180}
                                        height={48}
                                        style={{
                                            borderRadius: '8px',
                                            border: '1px solid #e5e7eb',
                                        }}
                                    />
                                    <button
                                        type="button"
                                        onClick={refreshCaptcha}
                                        title="Refresh CAPTCHA"
                                        style={{
                                            background: 'none',
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '8px',
                                            padding: '8px',
                                            cursor: 'pointer',
                                            color: '#6b7280',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        <LuRefreshCw size={18} />
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Enter CAPTCHA"
                                    value={captchaInput}
                                    onChange={(e) => {
                                        setCaptchaInput(e.target.value)
                                        setCaptchaError('')
                                    }}
                                    autoComplete="off"
                                    className="form-control form_input"
                                />
                                {captchaError && (
                                    <span className='text-danger' style={{ fontSize: '12px' }}>{captchaError}</span>
                                )}
                            </div>
                            <div className="col-md-12 text-end">
                                <Link to='/forgot-password'><span className='text-primary'>Forgot Password ?</span></Link>
                            </div>

                            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-3 mb-4 gap-2">
                                <div className="signup-info text-center text-sm-start mt-0">
                                    <p className='text-secondary mb-0' style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>Don't have an account yet? <Link to='/signup' ><span className='text-primary'> SIGN UP </span></Link> </p>
                                </div>
                                <div className="w-100 w-sm-auto text-center text-sm-end">
                                    <SaveButton
                                        spinner={spinner}
                                        button_name={'LOGIN'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default LoginForm;